import { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.sass';
import iconPlug from 'images/icon-plug.svg';
import imgPlug from 'images/img_plug.svg';
import amplitude from 'service/amplitude';

const cx = classnames.bind(styles);

/**
 * PlugGuidanceModal Component
 *
 * A modal component that displays charging gun connection instructions.
 * The mask cannot be clicked to close the modal - only the button can close it.
 *
 * @param {Object} props
 * @param {Object} props.data - Data object containing connector information
 * @param {string} props.data.serialNumber - The serial number of the EVSE
 * @param {Function} props.onButtonClick - Callback function when the button is clicked
 * @param {boolean} props.isOpen - Controls whether the modal is visible
 */

const PlugGuidanceModal = ({ data = {}, onButtonClick, isOpen }) => {
  const connectorId = data?.connectorId || '-';
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  useEffect(() => {
    if (isOpen) {
      amplitude.plugGuidanceModalOpen({ serialNumber: data.serialNumber });
    }
  }, [isOpen, data.serialNumber]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleButtonClick = () => {
    amplitude.plugGuidanceModalButtonOnClick({ serialNumber: data.serialNumber });
    setIsButtonClicked(true);
    onButtonClick?.();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={cx({ mask: true, show: isOpen && !isButtonClicked })}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <h1 className={styles.title}>請接上充電槍</h1>

          <div className={styles.chargingInfo}>
            <div className={styles.iconWrapper}>
              <img src={iconPlug} alt="plug" className={styles.icon} />
            </div>
            <div className={styles.infoText}>
              <div className={styles.infoLabel}>您正在使用充電槍號</div>
              <div className={styles.infoValue}>{connectorId}</div>
            </div>
          </div>

          <div className={styles.illustration}>
            <div className={styles.plugImageWrapper}>
              <div className={styles.glowCircle} />
              <img src={imgPlug} alt="plug" className={styles.img} />
            </div>
          </div>

          <p className={styles.instructions}>請拿取車位的充電槍並確實扣緊車輛， 需聽到「喀嗒」聲才算連接成功。</p>

          <button className={styles.confirmButton} onClick={handleButtonClick} type="button">
            充電槍已插好
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlugGuidanceModal;
